import { render } from "./OurDividends.vue?vue&type=template&id=48b00bb6&scoped=true"
import script from "./OurDividends.vue?vue&type=script&lang=js"
export * from "./OurDividends.vue?vue&type=script&lang=js"

import "./OurDividends.vue?vue&type=style&index=0&id=48b00bb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b00bb6"]])

export default __exports__